import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  recurso: {},
  arquivos: []
});

function recursoReducer(state = initialState, action) {
  switch (action.type) {
    case types.RECURSO_ARQUIVOS_START:
    case types.RECURSO_START: {
      return startLoad(state);
    }

    case types.RECURSO_ARQUIVOS_ERROR:
    case types.RECURSO_ERROR: {
      return endLoad(state);
    }

    case types.RECURSO_SUCCESS: {
      return endLoad(state.set('recurso', fromJS(action.payload)));
    }
    case types.RECURSO_ARQUIVOS_SUCCESS: {
      return endLoad(state.set('arquivos', fromJS(action.payload)));
    }
  }

  return state;
}

export default recursoReducer;
